import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { Badge } from "../Pill";

const BRAND_ROWS = [
  { name: "Recommended Vendor", price: "₹250 / mo" },
  { name: "Website + Instagram", price: "₹2,500 / mo" },
  { name: "Exclusive Feature", price: "Custom quote" },
];

const COUPLE_ROWS = [
  { name: "Editorial Feature", price: "Free" },
  { name: "Full Coverage", price: "₹25,000" },
  { name: "Exclusive Coverage", price: "₹50,000" },
];

function PlanCard({ title, sub, rows, dark, testid }) {
  return (
    <div
      data-testid={testid}
      className={`rounded-[2rem] p-7 md:p-10 h-full flex flex-col ${
        dark ? "bg-ink text-cream" : "bg-blush text-ink border-2 border-gold/15"
      }`}
    >
      <p className={`text-[10px] font-bold uppercase tracking-[0.25em] ${dark ? "text-champagne" : "text-gold"}`}>{title}</p>
      <p className={`mt-3 font-display uppercase text-2xl md:text-3xl leading-tight ${dark ? "text-cream" : "text-ink"}`}>{sub}</p>
      <div className={`mt-7 divide-y ${dark ? "divide-cream/10" : "divide-gold/15"}`}>
        {rows.map((r) => (
          <div key={r.name} className="py-4 flex items-center justify-between gap-4">
            <span className={`text-sm ${dark ? "text-cream/80" : "text-ink/80"}`}>{r.name}</span>
            <span className={`text-sm font-bold whitespace-nowrap ${dark ? "text-champagne" : "text-gold"}`}>{r.price}</span>
          </div>
        ))}
      </div>
      <Link
        to="/get-featured"
        data-testid={`${testid}-cta`}
        className={`group mt-8 inline-flex items-center justify-center gap-3 rounded-full pl-7 pr-2 py-2 text-xs font-bold uppercase tracking-[0.2em] transition-colors duration-300 ${
          dark ? "bg-champagne text-ink hover:bg-cream" : "bg-ink text-cream hover:bg-gold hover:text-ink"
        }`}
      >
        Get Featured
        <span className={`w-9 h-9 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:rotate-45 ${dark ? "bg-ink text-champagne" : "bg-champagne text-ink"}`}>
          <ArrowUpRight size={15} />
        </span>
      </Link>
    </div>
  );
}

export default function GetFeaturedSection() {
  return (
    <section data-testid="get-featured-section" className="bg-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><Badge tone="ink">Get Featured on TBOI</Badge></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display uppercase text-4xl md:text-5xl lg:text-6xl text-ink leading-[0.98]">
                Join 1000+ brands<br className="hidden md:block" /> and couples
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-neutral-600 leading-relaxed">
              Showcase your wedding or your work to one of the most engaged wedding audiences in the country, and
              across the diaspora.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          <Reveal>
            <PlanCard
              title="For Brands and Vendors"
              sub="Put your craft in front of 3Bn+ views"
              rows={BRAND_ROWS}
              dark
              testid="home-featured-brands"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <PlanCard
              title="For Couples"
              sub="Your wedding, chronicled by the best"
              rows={COUPLE_ROWS}
              testid="home-featured-couples"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
